export default {
  title: {
    en: 'Need help finding your scent?',
  },
  text: {
    en: 'Find your perfect scent with our fragrance quiz.',
  },
  buttonTitle: {
    en: 'Start your quiz',
  },
}
